import React from 'react';
import "../template-file-css/document-file-template.css";


export const RFS_AdultConcurrentFunctionCriteria = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='RFS_AdultConcurrentFunctionCriteria' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>Functional Impairments</h3></center></p>

                <p className='w-750'>
                    <span className='eleHeader'>Does the participant have a marked inability to establish or maintain competitive employment?</span>
                    <span className='small'>
                        Please provide explanation, if Yes or No

                    </span>
                    <input type='radio' id='rbDoesParticipantHaveMarkedInability_Yes' name='rbDoesParticipantHaveMarkedInability' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDoesParticipantHaveMarkedInability_No' name='rbDoesParticipantHaveMarkedInability' className='add-only' value='No' /> No <br />
                    <textarea id='txtDoesPartipantHaveMarkedInabilityToEstablish' name='txtDoesPartipantHaveMarkedInabilityToEstablish' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Does the participant have marked inability to perform instrumental activities of daily living
                        (eg: shopping, meal preparation, laundry, basic housekeeping, medication management,
                        transportation, and money management)?
                    </span>
                    <span className='small'>
                        Please provide explanation, if Yes or No

                    </span>
                    <input type='radio' id='rbDoesTheParticipantHaveMarkedInability_Yes' name='rbDoesTheParticipantHaveMarkedInability' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDoesTheParticipantHaveMarkedInability_No' name='rbDoesTheParticipantHaveMarkedInability' className='add-only' value='No' /> No<br />
                    <textarea id='txtDoesTheParticipantHaveMarkedInability' name='txtDoesTheParticipantHaveMarkedInability' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Does the participant have marked inability to establish/maintain a personal support system?
                    </span>
                    <span className='small'>
                        Please provide explanation, if Yes or No

                    </span>
                    <input type='radio' id='rbDoesTheParticipantHaveMaintain_Yes' name='rbDoesTheParticipantHaveMaintain' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDoesTheParticipantHaveMaintain_No' name='rbDoesTheParticipantHaveMaintain' className='add-only' value='No' /> No<br />
                    <textarea id='txtDoesTheParticipantHaveMaintain' name='txtDoesTheParticipantHaveMaintain' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Does participant have deficiencies of concentration/ persistence/pace leading to failure to
                        complete tasks?**
                    </span>
                    <span className='small'>
 Please provide explanation, if Yes or No
                    </span>
                    <input type='radio' id='rbDoesParticipantHaveDeficiencies_Yes' name='rbDoesParticipantHaveDeficiencies' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDoesParticipantHaveDeficiencies_No' name='rbDoesParticipantHaveDeficiencies' className='add-only' value='No' /> No<br />
                    <textarea id='txtDoesParticipantHaveDeficiencies' name='txtDoesParticipantHaveDeficiencies' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Is the participant unable to perform self-care (hygiene, grooming, nutrition, medical care,
                        safety)?**
                        
                    </span>
                    <span className='small'>
Please provide explanation, if Yes or No
                    </span>
                    <input type='radio' id='rbIsTheParticipantUnableToPerformSelfCare_Yes' name='rbIsTheParticipantUnableToPerformSelfCare' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIsTheParticipantUnableToPerformSelfCare_No' name='rbIsTheParticipantUnableToPerformSelfCare' className='add-only' value='No' /> No<br />
                    <textarea id='txtIsTheParticipantUnableToPerformSelfCare' name='txtIsTheParticipantUnableToPerformSelfCare' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Does the participant have marked deficiencies in self-direction, shown by inability to plan,
                        initiate, organize and carry out goal directed activities?**</span>
                    <span className='small'>

                        Please provide explanation, if Yes or No
                    </span>
                    <input type='radio' id='rbDoesTheParticipantHaveDeficienciesSelfDirection_Yes' name='rbDoesTheParticipantHaveDeficienciesSelfDirection' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDoesTheParticipantHaveDeficienciesSelfDirection_No' name='rbDoesTheParticipantHaveDeficienciesSelfDirection' className='add-only' value='No' /> No<br />
                    <textarea id='txtDoesTheParticipantHaveDeficienciesSelfDirection' name='txtDoesTheParticipantHaveDeficienciesSelfDirection' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Does the participant have marked inability to procure financial assistance to
                        support community living?**</span>
                    <span className='small'>

                        Please provide explanation, if Yes or No
                    </span>
                    <input type='radio' id='rbDoesTheParticipantHaveMarkedInabilityProcure_Yes' name='rbDoesTheParticipantHaveMarkedInabilityProcure' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDoesTheParticipantHaveMarkedInabilityProcure_No' name='rbDoesTheParticipantHaveMarkedInabilityProcure' className='add-only' value='No' /> No<br />
                    <textarea id='txtDoesTheParticipantHaveMarkedInabilityProcure' name='txtDoesTheParticipantHaveMarkedInabilityProcure' className='add-only'></textarea></p>

                <p className='w-750'><h4><b>Duration of Impairment(s):</b>
                </h4></p>

                <p className='w-750'>
                    <span className='eleHeader'>Has participant demonstrated marked functional impairments for at least 2 years?**</span>
                    <span className='small'>

                        Please provide explanation, if Yes or No
                    </span>
                    <input type='radio' id='rbHasParticipantDemostratedMarkedImpairments_Yes' name='rbHasParticipantDemostratedMarkedImpairments' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHasParticipantDemostratedMarkedImpairments_No' name='rbHasParticipantDemostratedMarkedImpairments' className='add-only' value='No' /> No<br />
                    <textarea id='txtHasParticipantDemostratedMarkedImpairments' name='txtHasParticipantDemostratedMarkedImpairments' className='add-only'></textarea></p>

                <p className='w-750'><h5><b>Alternative Service and Transition Considerations</b></h5></p>

                <p className='w-750'>
                    <span className='eleHeader'>Has consideration been given to using peer supports and other informal supports such as
                        family?**</span>
                    <span className='small'>

                        Please provide explanation, if Yes or No
                    </span>
                    <input type='radio' id='rbHasConsiderationBeenGivenUsingPeerSupports_Yes' name='rbHasConsiderationBeenGivenUsingPeerSupports' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHasConsiderationBeenGivenUsingPeerSupports_No' name='rbHasConsiderationBeenGivenUsingPeerSupports' className='add-only' value='No' /> No<br />
                    <textarea id='txtHasConsiderationBeenGivenUsingPeerSupports' name='txtHasConsiderationBeenGivenUsingPeerSupports' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Has participant been judged to be in enough behavioral control to be safe in rehab program
                        and benefit from the rehab provided?**
                    </span>
                    <span className='small'>

                        Please provide explanation, if Yes or No
                    </span>
                    <input type='radio' id='rbHasParticipantBeenJudgedToBeInEnoughBehavioralControl_Yes' name='rbHasParticipantBeenJudgedToBeInEnoughBehavioralControl' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHasParticipantBeenJudgedToBeInEnoughBehavioralControl_No' name='rbHasParticipantBeenJudgedToBeInEnoughBehavioralControl' className='add-only' value='No' /> No<br />
                    <textarea id='txtHasParticipantBeenJudgedToBeInEnoughBehavioralControl' name='txtHasParticipantBeenJudgedToBeInEnoughBehavioralControl' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>List specific ways in which PRP services are expected to help this individual:*
                    </span>
                    <span className='small'>

                        Please provide explanation, if Yes or No
                    </span>
                    <input type='radio' id='rbListSpecificWaysInWhichServicesIndividual_Yes' name='rbListSpecificWaysInWhichServicesIndividual' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbListSpecificWaysInWhichServicesIndividual_No' name='rbListSpecificWaysInWhichServicesIndividual' className='add-only' value='No' /> No<br />
                    <textarea id='txtListSpecificWaysInWhichServicesIndividual' name='txtListSpecificWaysInWhichServicesIndividual' className='add-only'></textarea></p>








            </div>
        </form>
    )
}